/**
 * 从 localStorage 读取并解析 JSON
 * @param {string} key
 * @returns {*} 解析后的值，读取失败或不存在时返回 null
 */
export function storageGet(key) {
	try {
		const val = localStorage.getItem(key)
		return val ? JSON.parse(val) : null
	} catch {
		return null
	}
}

/**
 * 将值 JSON 序列化后写入 localStorage
 * @param {string} key
 * @param {*} value
 */
export function storageSet(key, value) {
	try {
		localStorage.setItem(key, JSON.stringify(value))
	} catch {
		/* ignore */
	}
}
